import { useState, useEffect } from 'react'
import { VITE_API_BASE } from '../config/apiConfig'

const API = VITE_API_BASE

export default function ClaimCodeRedeem() {
  const urlParams = new URLSearchParams(window.location.search)
  const urlCode = urlParams.get('code') || ''

  const [code, setCode] = useState(urlCode)
  const [result, setResult] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [redeeming, setRedeeming] = useState(false)
  const [autoVerified, setAutoVerified] = useState(false)

  useEffect(() => {
    if (urlCode && !autoVerified) {
      setAutoVerified(true)
      verifyCode(urlCode)
    }
  }, [])

  const verifyCode = async (c) => {
    if (!c.trim()) { setError('请输入领取码'); return }
    setLoading(true); setError(''); setResult(null)
    try {
      const res = await fetch(`${API}/claim-codes/verify`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ code: c.trim().toUpperCase() }) })
      const data = await res.json()
      if (data.success) setResult(data.data)
      else setError(data.error || '领取码无效')
    } catch { setError('网络错误，请稍后重试') }
    finally { setLoading(false) }
  }

  const handleRedeem = async () => {
    if (!result) return
    setRedeeming(true)
    try {
      const res = await fetch(`${API}/claim-codes/redeem`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ code: code.trim().toUpperCase(), parent_phone: '' }) })
      const data = await res.json()
      if (data.success) { alert('🎉 领取成功！作品已存入孩子的数字资产'); setResult(null); setCode('') }
      else setError(data.error || '领取失败')
    } catch { setError('领取失败，请稍后重试') }
    finally { setRedeeming(false) }
  }

  const typeMap = { growth_video: '🎬 成长纪念视频', painting_video: '🎨 画作动画', ai_animation: '🤖 AI动画' }

  const handleBack = () => {
    const query = new URLSearchParams(window.location.search)
    const from = query.get('from')
    if (from === 'cms' || (document.referrer && document.referrer.includes('/cms/'))) {
      // 如果是在CMS中打开的，返回CMS
      window.location.href = '/cms/'
    } else if (window.history.length > 1) {
      window.history.back()
    } else {
      // 没有历史记录，直接跳转到CMS首页
      window.location.href = '/cms/'
    }
  }

  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', padding: '40px 20px' }}>
      <div style={{ maxWidth: 480, margin: '0 auto' }}>
        <button onClick={handleBack} style={{ background: 'rgba(255,255,255,0.2)', border: 'none', color: '#fff', padding: '8px 16px', borderRadius: 20, cursor: 'pointer', fontSize: 13, marginBottom: 16 }}>← 返回 CMS</button>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ fontSize: 64, marginBottom: 16 }}>🎁</div>
          <h1 style={{ color: '#fff', fontSize: 24, marginBottom: 8 }}>博小兔成长礼遇</h1>
          <p style={{ color: 'rgba(255,255,255,0.8)', fontSize: 14 }}>输入领取码，领取孩子的专属作品</p>
        </div>
        <div style={{ background: '#fff', borderRadius: 16, padding: 32, boxShadow: '0 8px 32px rgba(0,0,0,0.1)' }}>
          <div style={{ marginBottom: 20 }}>
            <label style={{ display: 'block', marginBottom: 8, fontSize: 14, color: '#666', fontWeight: 500 }}>领取码</label>
            <input type="text" value={code} onChange={e => setCode(e.target.value.toUpperCase())} placeholder={urlCode || "请输入领取码"} style={{ width: '100%', padding: '16px 20px', fontSize: 18, fontFamily: 'monospace', letterSpacing: 2, border: '2px solid #e8e8e8', borderRadius: 12, boxSizing: 'border-box', textAlign: 'center' }} onKeyDown={e => e.key === 'Enter' && verifyCode(code)} />
          </div>
          {error && <div style={{ padding: '12px 16px', background: '#fff1f0', color: '#f5222d', borderRadius: 8, marginBottom: 16, fontSize: 14 }}>{error}</div>}
          <button onClick={() => verifyCode(code)} disabled={loading} style={{ width: '100%', padding: '16px', fontSize: 16, fontWeight: 600, background: loading ? '#ccc' : '#1890ff', color: '#fff', border: 'none', borderRadius: 12, cursor: loading ? 'not-allowed' : 'pointer' }}>{loading ? '验证中...' : '验证领取码'}</button>

          {result && (
            <div style={{ marginTop: 24, padding: 20, background: '#f6ffed', borderRadius: 12, border: '1px solid #b7eb8f' }}>
              <div style={{ textAlign: 'center', marginBottom: 16 }}>
                <div style={{ fontSize: 48, marginBottom: 8 }}>🎬</div>
                <h3 style={{ fontSize: 18, marginBottom: 4 }}>{result.title || '成长纪念作品'}</h3>
                <p style={{ fontSize: 13, color: '#666' }}>孩子：{result.child_name}</p>
              </div>
              <div style={{ fontSize: 13, color: '#666', marginBottom: 16 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}><span>作品类型：</span><span style={{ color: '#1890ff' }}>{typeMap[result.product_type] || '其他'}</span></div>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}><span>状态：</span><span style={{ color: result.status === 'claimed' ? '#f5222d' : '#52c41a' }}>{result.status === 'claimed' ? '已领取' : '待领取'}</span></div>
              </div>
              {(result.status === 'unused' || result.status === 'available') && <button onClick={handleRedeem} disabled={redeeming} style={{ width: '100%', padding: '14px', fontSize: 15, fontWeight: 600, background: redeeming ? '#ccc' : '#52c41a', color: '#fff', border: 'none', borderRadius: 10, cursor: redeeming ? 'not-allowed' : 'pointer' }}>{redeeming ? '领取中...' : '🎁 立即领取'}</button>}
              {(result.status === 'claimed' || result.status === 'redeemed') && result.video_url && <a href={result.video_url} download style={{ display: 'block', width: '100%', padding: '12px', fontSize: 14, fontWeight: 600, background: '#1890ff', color: '#fff', border: 'none', borderRadius: 10, cursor: 'pointer', textDecoration: 'none', textAlign: 'center' }}>📥 下载视频</a>}
            </div>
          )}
        </div>
        <div style={{ textAlign: 'center', marginTop: 24, color: 'rgba(255,255,255,0.7)', fontSize: 13 }}>
          <p>领取码由博小兔活动老师生成</p>
          <p style={{ marginTop: 8 }}>如有疑问请联系活动组织方</p>
        </div>
      </div>
    </div>
  )
}
